<div class="flex w-full items-center justify-center p-8 text-secondary">
    <zop-card class="flex flex-col items-center max-w-80 w-full p-8 pb-6">
        <div class="flex w-full justify-end">
            <button mat-icon-button [matMenuTriggerFor]="menuUserOptions">
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:ellipsis-vertical'"
                ></mat-icon>
            </button>
            <mat-menu #menuUserOptions="matMenu">
                <button mat-menu-item>Upload Photo</button>
                <button mat-menu-item>Edit Profile</button>
                <button mat-menu-item>Change Password</button>
            </mat-menu>
        </div>
        <!-- <img
            class="w-32 h-32 rounded-full"
            src="assets/images/avatars/male-04.jpg"
            alt="Card cover image"
        /> -->
        <div class="flex flex-auto items-center min-w-0 mt-4">
            <div
                class="flex items-center justify-center w-32 h-32 rounded-full overflow-hidden bg-[#FE4F30] text-black text-center text-4xl"
            >
                {{ selectedUser?.displayName?.charAt(0)?.toUpperCase() }}
            </div>
        </div>

        <div
            class="text-2xl font-semibold leading-tight text-center mt-8 text-black"
            >{{ selectedUser?.salutation }}.
            {{ selectedUser?.firstName | titlecase }}
            {{ selectedUser?.lastName | titlecase }}</div
        >
        <div class="text-secondary leading-tight text-center mt-1">{{
            selectedUser?.displayName
        }}</div>
        <hr class="w-full border-t my-6" />
        <div class="flex flex-col gap-2">
            <div class="flex items-center">
                <mat-icon
                    class="icon-size-5 mr-3"
                    [svgIcon]="'heroicons_solid:envelope'"
                ></mat-icon>
                <span class="leading-none">
                    {{ selectedUser?.email?.value }}</span
                >
            </div>
            <div class="flex items-center mt-4">
                <mat-icon
                    class="icon-size-5 mr-3"
                    [svgIcon]="'heroicons_solid:device-phone-mobile'"
                ></mat-icon>
                <span class="leading-none"
                    >{{ selectedUser?.mobileNumber?.countryCode }}-{{
                        selectedUser?.mobileNumber?.value
                    }}</span
                >
            </div>
            <div class="flex items-center mt-4">
                <mat-icon
                    class="icon-size-5 mr-3"
                    [svgIcon]="'heroicons_solid:calendar'"
                ></mat-icon>
                <span class="leading-none">{{
                    selectedUser?.createdTime | date : 'medium'
                }}</span>
            </div>
        </div>
    </zop-card>
</div>
